import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, set } from "react-hook-form";
import {
  getComProductAll,
  inActiveComProduct,
  deleteComProduct,
  createComProduct,
  updateComProduct,
} from "../../Services/ComProductService";
import Overlay from "../../Components/Overlay/Overlay";
import { getSegmentAll } from "../../Services/SegmentService";
import { getCategoryAll } from "../../Services/CategoryService";
import { getSubcategoryAll } from "../../Services/SubcategoryService";
import { getSubSubcategoryAll } from "../../Services/SubSubcategoryService";
import { getComBrandAll } from "../../Services/ComBrandService";
import { InputSwitch } from "primereact/inputswitch";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import EditButton from "../../Components/Button/EditButton";
import DeleteButton from "../../Components/Button/DeleteButton";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { image_default } from "../../Images";
import ModalFormFeature from "../../Components/Product/Modal/ModalFormFeature";
import {
  getFeatureBySubCategory,
  getFeatureMappingBySubCat,
} from "../../Services/FeatureService";

const { $ } = window;
let processingId = -1;
const modalId10 = "#product-create-feature-score";

const ComProductPage = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const mTable = useRef();
  const darkMode = useSelector((state) => state.theme.darkMode);
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      is_active: true,
      product_class: "",
    },
  });

  const [state, setState] = useState({
    showForm: false,
    product: {},
    id_segment: "",
    id_category: "",
    id_sub_category: "",
    id_sub_sub_category: "",
    id_brand: "",
    sales_code: "",
    product_name: "",
    product_description: "",
    product_feature: "",
    product_dimension: "",
    remarks: "",
    options: [],
    segments: [],
    categories: [],
    sub_categories: [],
    sub_sub_categories: [],
    brands: [],
    product_class: "",
    processing: false,
    disabled: false,
    totScoreFeature: 0,
    reqFeature: [],
    feature_type: [],
    sub_sub_category: {},
  });

  const columns = [
    {
      id: uuid(),
      title: "Brand",
      field: "brand_name",
      sortable: true,
      options: state.options,
    },
    { id: uuid(), title: "Sales Code", field: "sales_code", sortable: true },
    {
      id: uuid(),
      title: "Product Name",
      field: "product_name",
      sortable: true,
      style: {
        overflow: `hidden`,
        textOverflow: `ellipsis`,
        width: 250,
      },
    },
    {
      id: uuid(),
      title: "Segment",
      field: "segment_name",
      sortable: true,
      options: state.options,
    },
    {
      id: uuid(),
      title: "Category",
      field: "category_name",
      sortable: true,
      options: state.options,
    },
    {
      id: uuid(),
      title: "Sub Category",
      field: "sub_category_name",
      sortable: true,
      options: state.options,
    },
    {
      id: uuid(),
      title: "Sub-Sub Category",
      field: "sub_sub_category_name",
      sortable: true,
      options: state.options,
    },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "Action",
      render: (item) => {
        return (
          <div>
            {userInfo.access.competitor_product.can_update && (
              <EditButton title="Edit" onClick={onEdit(item)} />
            )}
            {userInfo.access.competitor_product.can_delete && (
              <DeleteButton title="Remove" onClick={onRemove(item)} />
            )}
          </div>
        );
      },
    },
  ];

  const onAddFeatureModal = (a) => {
    if (Array.isArray(a)) {
      setTimeout(() => {
        $(modalId10).modal("show");
      }, 150);
    } else {
      getFeatureBySubCategory(a, ({ data }) => {
        setState((prev) => ({
          ...prev,
          reqFeature: data,
          id_sub_sub_category: a,
        }));
      });
      setTimeout(() => {
        $(modalId10).modal("show");
      }, 150);
    }
  };

  const onCloseModal4 = () => {
    setTimeout(() => {
      $(modalId10).modal("hide");
    }, 150);
  };

  const onSaveFeature = (reqF, totScore, productClass) => {
    if (totScore < reqF.length) {
      toastError("Please complete score feature type!");
      return;
    } else {
      const _feature_type = [...reqF];

      _feature_type.map((item, i) => {
        item.own = false;
      });

      setState({
        ...state,
        reqFeature: reqF,
        totScoreFeature: totScore,
        feature_type: _feature_type,
        product_class: productClass,
      });
      setTimeout(() => {
        $(modalId10).modal("hide");
        setValue("product_class", productClass);
      }, 150);
    }
  };

  const setChange = (e) => {
    switch (e.target.name) {
      case "id_segment":
        getCategoryAll(
          { perpage: 100, filter: `id_segment:${e.target.value}` },
          ({ data }) => {
            setState({
              ...state,
              categories: data.data,
              sub_categories: [],
              sub_sub_categories: [],
            });
          }
        );
        break;
      case "id_category":
        getSubcategoryAll(
          { perpage: 100, filter: `id_category:${e.target.value}` },
          ({ data }) => {
            setState({
              ...state,
              sub_categories: data.data,
              sub_sub_categories: [],
            });
          }
        );
        break;
      case "id_sub_category":
        getSubSubcategoryAll(
          { perpage: 100, filter: `id_sub_category:${e.target.value}` },
          ({ data }) => {
            setValue("product_class", "");
            setState({
              ...state,
              sub_sub_categories: data.data,
              id_sub_category: e.target.value,
              totScoreFeature: 0,
              reqFeature: [],
              feature_type: [],
            });
          }
        );
        break;
      default:
        break;
    }
  };

  const onSubSubCategoryChange = (e) => {
    const _sub_sub_category = sub_sub_categories.find(
      (item) => item.id == e.target.value
    );
    setValue("product_class", "");
    getFeatureBySubCategory(_sub_sub_category?.id).then((res) => {
      const { data } = res;
      setState((prev) => ({
        ...prev,
        reqFeature: data,
        totScoreFeature: 0,
        sub_sub_category: _sub_sub_category,
        product_class: "",
      }));
    });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onSelectImage = () => {
    $("#product-image").click();
  };

  const onBack = () => {
    navigate(-1);
  };

  const onproductImageChange = (e) => {
    const [file] = e.target.files;
    if (file) {
      const _product = {
        ...product,
        image_url: URL.createObjectURL(file),
        file,
      };
      setState({ ...state, product: _product });
    }
  };

  const onSubmit = (data) => {
    data.image = product.file;
    const formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }

    for (let ft in feature_type) {
      let dataFeature = feature_type[ft];
      if (feature_type[ft].score > 0) {
        for (let fD in dataFeature) {
          formData.append(`feature_type[${ft}][${fD}]`, feature_type[ft][fD]);
        }
      } else {
        toastError("Please fill all score feature type!");
        return;
      }
    }

    startProcessing();
    const response = product.id
      ? updateComProduct(product.id, formData)
      : createComProduct(formData);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Save data success",
            text: "Data has been saved!",
          }).then((r) => {
            mTable.current.refresh();
            product.id ? onCloseForm() : onReset();
          });
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const onRemove = (item) => () => {
    if (!userInfo.access.competitor_product.can_delete) {
      toastError("You dont have permission for this action");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeData(item.id);
      }
    });
  };

  const onEdit = (item) => () => {
    if (!userInfo.access.competitor_product.can_update) {
      return;
    }
    const results = [
      getCategoryAll({
        perpage: 100,
        filter: `id_segment:${item.id_segment}`,
      }).then((res) => res.data.data),
      getSubcategoryAll({
        perpage: 100,
        filter: `id_category:${item.id_category}`,
      }).then((res) => res.data.data),
      getSubSubcategoryAll({
        perpage: 100,
        filter: `id_sub_category:${item.id_sub_category}`,
      }).then((res) => res.data.data),
      getComBrandAll({ perpage: 100 }).then((res) => res.data.data),
      getFeatureMappingBySubCat(
        item.sales_code.replace(/\//g, "%2F"),
        item.id_sub_sub_category
      ).then((res) => res.data),
    ];
    Promise.all(results).then((results) => {
      const [_category, _subcategory, _subsubcategory, _brand, _reqFeature] =
        results;
      item.image_url =
        item.image != null
          ? item.image.toString().includes(process.env.REACT_APP_IMAGE)
            ? item.image
            : process.env.REACT_APP_IMAGE + item.image
          : null;
      reset(item);
      const _sub_sub_category = _subsubcategory.find(
        (x) => x.id == item.id_sub_sub_category
      );
      setState({
        ...state,
        categories: _category,
        sub_categories: _subcategory,
        sub_sub_categories: _subsubcategory,
        sub_sub_category: _sub_sub_category,
        brands: _brand,
        product: item,
        showForm: true,
        disabled: true,
        product_class: item.product_class,
        id_sub_category: item.id_sub_category,
        reqFeature: _reqFeature.productFeature,
        totScoreFeature: _reqFeature.totScoreFeature,
      });
    });
  };

  const onAddData = () => {
    if (!userInfo.access.competitor_product.can_create) {
      return;
    }
    onReset();
    setState({ ...state, showForm: true, disabled: false });
  };

  const removeData = (id) => {
    deleteComProduct(
      id,
      (res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Delete data success",
            text: "Data has been deleted!",
          }).then((res) => {
            mTable.current.refresh();
          });
        }
      },
      ({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Delete data fail",
          text: data.message,
        });
      }
    );
  };

  const onActiveChange = (item) => (e) => {
    if (item._id == userInfo.userid) {
      toastError(`Can't change status of your account!`);
      return;
    }
    const status = e.target.value ? "Activate" : "Inactive";
    inActiveComProduct(item.id, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  const onReset = () => {
    reset({
      id_segment: "",
      id_category: "",
      id_sub_category: "",
      id_sub_sub_category: "",
      id_brand: "",
      sales_code: "",
      product_name: "",
      product_description: "",
      product_feature: "",
      product_dimension: "",
      product_class: "",
      remarks: "",
      segments: [],
      categories: [],
      sub_categories: [],
      sub_sub_categories: [],
      brands: [],
      product_class: "",
      totScoreFeature: 0,
      reqFeature: [],
      feature_type: [],
    });
  };

  const onCloseForm = () => {
    onReset();
    setState({
      ...state,
      segment: [],
      showForm: false,
      disabled: false,
      feature_type: [],
      reqFeature: [],
      totScoreFeature: 0,
      id_sub_category: 0,
      product_class: "",
      product: {},
    });
  };

  useEffect(() => {
    const requests = [
      getSegmentAll({ perpage: 100 }).then((res) => res.data.data),
      getComBrandAll({ perpage: 100 }).then((res) => res.data.data),
    ];
    Promise.all(requests).then((results) => {
      const [_segments, _brand] = results;
      setState({ ...state, segments: _segments, brands: _brand, product: {} });
    });
  }, []);

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    defaultSort: "id",
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (showAll === false) {
        if (params.filterAnd) params.filterAnd += "," + `is_active:true`;
        else params.filterAnd = "is_active:true";
      }
      return getComProductAll({ ...params });
    },
    showIndex: true,
    showAddButton: !userInfo.access.competitor_product.can_create
      ? false
      : true,
    onAddData,
    enableFilter: true,
  };

  const {
    product,
    totScoreFeature,
    reqFeature,
    processing,
    feature_type,
    product_class,
    showForm,
    disabled,
    id_sub_category,
    sub_sub_category,
    sub_sub_categories,
    id_sub_sub_category,
  } = state;

  const propsModalProductFeature = {
    sub_sub_category,
    modalId10,
    onCloseModal4,
    reqFeature,
    totScoreFeature,
    onAddFeatureModal,
    onSaveFeature,
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                {showForm
                  ? "Competitor Product Form"
                  : "Competitor Product Management"}
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                {showForm
                  ? "Add/Edit a competitor product"
                  : "Database of Competitor Products"}
              </h6>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Competitor</li>
                <li className="breadcrumb-item active">Product</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <Overlay display={processing} />

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="card-body">
                    <div
                      className={`${!showForm
                          ? "card__side--front-show"
                          : "card__side--front"
                        }`}
                    >
                      <MTable ref={mTable} {...propsTable} order="full_name" />
                    </div>
                    <div
                      className={`${showForm ? "card__side--back-show" : "card__side--back"
                        }`}
                    >
                      <div className="row" style={{ paddingLeft: 20 }}>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Segment</label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_segment"
                                className="form-control"
                                {...register("id_segment", {
                                  required: {
                                    value: true,
                                    message: "Segment is required!",
                                  },
                                })}
                                onChange={setChange}
                              >
                                <option value={""}>Select Segment</option>
                                {state.segments.map((seg, i) => (
                                  <option key={`ctg-` + i} value={seg.id}>
                                    {seg.segment_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_segment && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_segment.message}
                                </span>
                              )}
                            </fieldset>
                          </div>

                          <div className="form-group">
                            <label>Category</label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_category"
                                className="form-control"
                                {...register("id_category", {
                                  required: {
                                    value: true,
                                    message: "Category is required!",
                                  },
                                })}
                                onChange={setChange}
                              >
                                <option value={""}>Select Category</option>
                                {state.categories.map((cat, i) => (
                                  <option key={`ctg-` + i} value={cat.id}>
                                    {cat.category_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_category && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_category.message}
                                </span>
                              )}
                            </fieldset>
                          </div>

                          <div className="form-group">
                            <label>Sub Category</label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_sub_category"
                                className="form-control"
                                {...register("id_sub_category", {
                                  required: {
                                    value: true,
                                    message: "Sub Category is required!",
                                  },
                                })}
                                onChange={setChange}
                              >
                                <option value={""}>Select Sub Category</option>
                                {state.sub_categories.map((cat, i) => (
                                  <option key={`ctg-` + i} value={cat.id}>
                                    {cat.sub_category_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_sub_category && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_sub_category.message}
                                </span>
                              )}
                            </fieldset>
                          </div>

                          <div className="form-group">
                            <label htmlFor="id_sub_sub_category">
                              Sub Sub Category
                            </label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_sub_sub_category"
                                className="form-control"
                                {...register("id_sub_sub_category", {
                                  required: {
                                    value: true,
                                    message: "Sub-Sub Category is required!",
                                  },
                                  onChange: onSubSubCategoryChange,
                                })}
                              >
                                <option value={""}>
                                  Select Sub Sub Category
                                </option>
                                {state.sub_sub_categories.map((cat, i) => (
                                  <option key={`ctg-` + i} value={cat.id}>
                                    {cat.sub_sub_category_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_sub_sub_category && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_sub_sub_category.message}
                                </span>
                              )}
                            </fieldset>
                          </div>

                          <div className="form-group">
                            <label htmlFor="id_brand">Brand</label>
                            <fieldset disabled={disabled}>
                              <select
                                id="id_brand"
                                className="form-control"
                                {...register("id_brand", {
                                  required: {
                                    value: true,
                                    message: "Brand is required!",
                                  },
                                })}
                              >
                                <option value={""}>Select Brand</option>
                                {state.brands.map((cat, i) => (
                                  <option key={`ctg-` + i} value={cat.id}>
                                    {cat.brand_name}
                                  </option>
                                ))}
                              </select>
                              {errors.id_brand && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: 14 }}
                                >
                                  {errors.id_brand.message}
                                </span>
                              )}
                            </fieldset>
                          </div>

                          <div className="form-group">
                            <label htmlFor="sales_code">Sales Code</label>
                            <input
                              id="sales_code"
                              {...register("sales_code", {
                                required: {
                                  value: true,
                                  message: "Sales Code is required!",
                                },
                              })}
                              placeholder="Sales Code"
                              className="form-control"
                            />
                            {errors.sales_code && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.sales_code.message}
                              </span>
                            )}
                          </div>

                          <div className="form-group">
                            <label htmlFor="product_name">Product Name</label>
                            <input
                              id="product_name"
                              {...register("product_name", {
                                required: {
                                  value: true,
                                  message: "Product Name is required!",
                                },
                              })}
                              placeholder="Product Code"
                              className="form-control"
                            />
                            {errors.product_name && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.product_name.message}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-5" style={{ paddingLeft: 20 }}>
                          <div className="form-group">
                            <label htmlFor="product_description">
                              Product Description
                            </label>
                            <textarea
                              style={{ resize: "none", whiteSpace: "pre-wrap" }}
                              id="product_description"
                              {...register("product_description")}
                              className="form-control"
                              rows={2}
                              disabled={false}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="product_feature">
                              Product Feature
                            </label>
                            <textarea
                              style={{ resize: "none", whiteSpace: "pre-wrap" }}
                              id="product_feature"
                              {...register("product_feature")}
                              className="form-control"
                              rows={3}
                              disabled={false}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="product_dimension">
                              Product Dimension
                            </label>
                            <textarea
                              style={{ resize: "none", whiteSpace: "pre-wrap" }}
                              id="product_dimension"
                              {...register("product_dimension")}
                              className="form-control"
                              rows={3}
                              disabled={false}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <textarea
                              style={{ resize: "none", whiteSpace: "pre-wrap" }}
                              id="remarks"
                              {...register("remarks")}
                              className="form-control"
                              rows={3}
                              disabled={false}
                            />
                          </div>

                          <div className="row">
                            <div className="form-group col-8">
                              <label htmlFor="product_class">
                                Product Class
                              </label>
                              <input
                                id="product_class"
                                {...register("product_class")}
                                placeholder=""
                                className="form-control"
                                readOnly={true}
                              />
                            </div>
                            {reqFeature && reqFeature.length > 0 ? (
                              <div className="col-3" style={{ marginTop: 32 }}>
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  onClick={() => onAddFeatureModal(reqFeature)}
                                  disabled={reqFeature.length == 0}
                                >
                                  {" "}
                                  Manage Score{" "}
                                </button>
                              </div>
                            ) : (
                              <div className="col-3" style={{ marginTop: 32 }}>
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  onClick={() =>
                                    onAddFeatureModal(id_sub_sub_category)
                                  }
                                  disabled={id_sub_sub_category == 0}
                                >
                                  {" "}
                                  Manage Score{" "}
                                </button>
                              </div>
                            )}
                            <div className="form-group col-1 text-center">
                              <label htmlFor="active">Active</label>
                              <div>
                                <Controller
                                  name="is_active"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                        disabled={false}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="col-md-12 d-flex flex-column align-items-center">
                            <label>Product Image</label>
                            <div className="mb-4">
                              <img
                                src={product.image_url || image_default}
                                alt="A"
                                className="elevation-2"
                                style={{ width: 160, height: 160 }}
                              />
                            </div>
                            <div className="mb-3">
                              <button
                                type="button"
                                className={`btn ${darkMode
                                    ? "btn-outline-warning"
                                    : "btn-outline-dark"
                                  }`}
                                onClick={onSelectImage}
                              >
                                <i className="fa fa-image" /> Select Image
                              </button>
                              <input
                                id="product-image"
                                type="file"
                                accept="image/png, image/jpg, image/jpeg"
                                {...register("image")}
                                className="d-none"
                                onChange={onproductImageChange}
                              />
                              {errors.image && (
                                <span className="text-danger d-block">
                                  {errors.image.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {showForm && (
                    <div className="card-footer delay">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="d-flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <button
                              type="button"
                              className="btn btn-default mr-3"
                              style={{ width: 100 }}
                              onClick={onCloseForm}
                            >
                              <i className="fa fa-times" /> Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger mr-3"
                              style={{ width: 100 }}
                              onClick={onReset}
                            >
                              <i className="fa fa-sync" /> Clear
                            </button>
                            <button
                              type="submit"
                              className="btn btn-dark"
                              style={{ width: 100 }}
                              disabled={
                                control._formValues.id
                                  ? !userInfo.access.competitor_product
                                    .can_update
                                  : !userInfo.access.competitor_product
                                    .can_create
                              }
                            >
                              <i className="fa fa-save" /> Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ModalFormFeature {...propsModalProductFeature} />
    </div>
  );
};

export default ComProductPage;
